import React from 'react';
import { motion } from 'motion/react';
import { cn } from '../../utils/cn';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="relative"
    >
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm",
          "ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2",
          "focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          "transition-all duration-200 ease-in-out",
          "hover:border-primary/50",
          className
        )}
        ref={ref}
        {...props}
      />
      <motion.div
        className="absolute inset-0 rounded-md pointer-events-none"
        initial={false}
        animate={{
          boxShadow: props.value ? '0 0 0 2px rgba(var(--primary), 0.1)' : 'none'
        }}
        transition={{ duration: 0.2 }}
      />
    </motion.div>
  );
});

Input.displayName = 'Input';

export { Input }; 